<template>
  <b-field>
    <b-input
      :placeholder="$tc('dater.range')"
      type="search"
      icon="magnify"
      icon-clickable
      v-model="filters.search"
      expanded
    ></b-input>

    <div class="control">
      <button type="reset" class="button" @click="reset">
        <b-icon icon="close"></b-icon>
        <span>{{$tc('reset')}}</span>
      </button>
    </div>
  </b-field>
</template>

<script>
export default {
  data() {
    return {
      filters: this.default()
    };
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        this.$emit("input", this.filters);
      }
    }
  },

  methods: {
    reset() {
      this.filters = this.default();
    },

    default() {
      return {
        email: null,
        publisher_id: null,
        id: null
      };
    }
  }
};
</script>
